module.exports = __webpack_public_path__ + "static/liuyishou@2x-2381697dbbc26709befef406973bd027.png";